import { useTilledPayoutsListQuery } from '@bambi/api-client/bambi';
import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import type { PaginationState } from '@tanstack/react-table';
import { useCallback, useState } from 'react';

import { columns } from './columns';
import { PayoutsEmptyState } from './PayoutsEmptyState';
import { useAppSelector } from 'src/app/store/hooks';
import { DataGrid } from 'src/common/DataGrid';
import { usePagination } from 'src/common/DataGrid/usePagination';

export function PayoutsDataGrid() {
  const [currentPage, setCurrentPage] = useState(1);
  const filterSearch = useAppSelector((state) => state.payouts.filterSearch);

  const { data, isLoading, refetch } = useTilledPayoutsListQuery({
    page: currentPage,
    invoiceNumber: filterSearch,
  });

  const handlePaginationUpdate = useCallback(
    (state: PaginationState) => {
      setCurrentPage(state.pageIndex + 1);
      refetch();
    },
    [refetch]
  );

  const { pagination, handlePaginationChange } = usePagination(
    handlePaginationUpdate
  );

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <DataGrid
      tableId="tilled-payouts"
      pagination={pagination}
      handlePaginationChange={handlePaginationChange}
      columns={columns}
      data={data?.results ?? []}
      totalCount={data?.count}
      emptyState={<PayoutsEmptyState />}
    />
  );
}
